export default "__VITE_ASSET__kHSDQQyi__";